<template>
    <div>
        <errors :error-list="serverErrors"></errors>
        <div class="property-card">
            <b class="property-name">PAX Affected</b>

            <!-- PAX -->
            <div class="pax" v-for="passenger in passengers">
                <div class="d-flex align-items-top">
                    <div class="flex-shrink-1 pr-2 checkbox-container">
                        <input :checked="isPaxAffected(passenger.passengerId)"
                                @change="togglePaxAffected(passenger.passengerId)"
                               :disabled="isSaving"
                               type="checkbox">
                    </div>
                    <div class="flex-grow-1">
                        {{ passenger.firstname }} {{ passenger.surname }}
                    </div>
                </div>
            </div>
            <!-- / PAX -->
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import {mapGetters, mapActions} from "vuex";
    import Forms from "../../../../../../mixins/Forms";

    export default {
        name: "PaxAffected",
        mixins: [Forms],
        data() {
            return {
                isSaving: false,
                serverErrors: []
            }
        },
        computed: {
            ...mapGetters('ticketViewer', {
                ticket: 'ticket',
                isLoadingAxumData: 'isLoadingAxumData',
                axumData: 'axumData'
            }),

            idsOfPaxAffected() {
                let ids = [];
                if (this.ticket) {
                    try {
                        ids = JSON.parse(this.ticket.pax_affected);
                    } catch {
                        ids = [];
                    }
                }
                return ids;
            },

            passengers() {
                if (this.axumData.passengers) {
                    return this.axumData.passengers;
                } else {
                    return [];
                }
            }
        },
        methods: {
            ...mapActions('ticketViewer', {
                updateTicketPropertySilently: 'updateTicketPropertySilently'
            }),

            isPaxAffected(passengerId) {
                if (this.idsOfPaxAffected && this.idsOfPaxAffected.length) {
                    return this.idsOfPaxAffected.includes(String(passengerId));
                } else {
                    return false;
                }
            },

            togglePaxAffected(passengerId) {
                let vm = this;

                if (vm.isSaving) {
                    return false;
                }

                vm.isSaving = true;
                let newPaxAffected = _.xor(this.idsOfPaxAffected, [String(passengerId)]);

                axios.put(API_BASE + '/tickets/' + this.ticket.id, {
                    pax_affected: JSON.stringify(newPaxAffected)
                }).then(r => {
                    vm.isSaving = false;
                    vm.updateTicketPropertySilently({
                        property: 'pax_affected',
                        value: newPaxAffected
                    })
                }).catch(e => {
                    console.log(e);
                    vm.isSaving = false;
                    vm.setErrors(e);
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    .property-card {
        background: #fff;
        border-radius: 5px;
        padding: 15px;

        .property-name {
            font-weight: 600;
            color: #2c5cc5;
        }

        .pax {
            margin-top: 10px;
        }
    }
</style>
